import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { boardingACHProcessor } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateACHProcessorDetailsMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({
			applicationId,
			fieldData,
			onSuccess,
		}: {
			applicationId: string;
			fieldData: {
				fieldBeName: string;
				fieldValue: string | number;
			};
			onSuccess?: () => void;
		}) => {
			return boardingACHProcessor.updateACHProcessorData({
				applicationId,
				fieldData,
			});
		},
		{
			onSuccess(data, { onSuccess }) {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateACHProcessorDetailsMutation;
